// extracted by mini-css-extract-plugin
export default {"root":"SelectAlbumPopup__root--1VDp3","modal":"SelectAlbumPopup__modal--2Xms0","title":"SelectAlbumPopup__title--3kr1J"};